// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineDocument = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.0007 15.1693H6.00065C2.38065 15.1693 0.833984 13.6226 0.833984 10.0026V6.0026C0.833984 2.3826 2.38065 0.835938 6.00065 0.835938H10.0007C13.6207 0.835938 15.1673 2.3826 15.1673 6.0026V10.0026C15.1673 13.6226 13.6207 15.1693 10.0007 15.1693ZM6.00065 1.83594C2.92732 1.83594 1.83398 2.92927 1.83398 6.0026V10.0026C1.83398 13.0759 2.92732 14.1693 6.00065 14.1693H10.0007C13.074 14.1693 14.1673 13.0759 14.1673 10.0026V6.0026C14.1673 2.92927 13.074 1.83594 10.0007 1.83594H6.00065Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.5 6.5H5.5C5.22667 6.5 5 6.27333 5 6C5 5.72667 5.22667 5.5 5.5 5.5H10.5C10.7733 5.5 11 5.72667 11 6C11 6.27333 10.7733 6.5 10.5 6.5Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.5 10.5H5.5C5.22667 10.5 5 10.2733 5 10C5 9.72667 5.22667 9.5 5.5 9.5H10.5C10.7733 9.5 11 9.72667 11 10C11 10.2733 10.7733 10.5 10.5 10.5Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineDocument };
